import { render, staticRenderFns } from "./NeedStartupSubmitModal.vue?vue&type=template&id=2ec74368&scoped=true&"
import script from "./NeedStartupSubmitModal.vue?vue&type=script&setup=true&lang=js&"
export * from "./NeedStartupSubmitModal.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec74368",
  null
  
)

export default component.exports